import { render } from "./pageComponent.vue?vue&type=template&id=d0367da8&scoped=true"
import script from "./pageComponent.vue?vue&type=script&lang=js"
export * from "./pageComponent.vue?vue&type=script&lang=js"

import "./pageComponent.vue?vue&type=style&index=0&id=d0367da8&scoped=true&lang=css"

import exportComponent from "E:\\develop\\company\\gw\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d0367da8"]])

export default __exports__